// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tests_container__naiHM {
  min-height: 100vh;
}
.Tests_carouselContainer__d-VEs {
  width: 100%;
  height: 500px;
  padding: 30px;
}
.Tests_sliderContainer__ceqqE {
  width: 400px;
  margin: auto;
  padding: 30px;
}
.Tests_textareaContainer__9EVkX {
  width: 400px;
  margin: auto;
  padding: 30px;
  height: 200px;
}
.Tests_textarea__kAnHO {
  resize: none;
  width: 300px;
  /* height: auto; */
  min-height: 100px;
  overflow-y: hidden;
  border: 1px solid #ccc;
  padding: 8px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TestPages/Tests.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":[".container {\r\n  min-height: 100vh;\r\n}\r\n.carouselContainer {\r\n  width: 100%;\r\n  height: 500px;\r\n  padding: 30px;\r\n}\r\n.sliderContainer {\r\n  width: 400px;\r\n  margin: auto;\r\n  padding: 30px;\r\n}\r\n.textareaContainer {\r\n  width: 400px;\r\n  margin: auto;\r\n  padding: 30px;\r\n  height: 200px;\r\n}\r\n.textarea {\r\n  resize: none;\r\n  width: 300px;\r\n  /* height: auto; */\r\n  min-height: 100px;\r\n  overflow-y: hidden;\r\n  border: 1px solid #ccc;\r\n  padding: 8px;\r\n  box-sizing: border-box;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tests_container__naiHM`,
	"carouselContainer": `Tests_carouselContainer__d-VEs`,
	"sliderContainer": `Tests_sliderContainer__ceqqE`,
	"textareaContainer": `Tests_textareaContainer__9EVkX`,
	"textarea": `Tests_textarea__kAnHO`
};
export default ___CSS_LOADER_EXPORT___;
